module.exports = __webpack_public_path__ + "static/media/check-cross-icon.0a8d7da7.svg";